import { Observable, take } from 'rxjs';

/**
 * Synchronously take the current value out of the store.
 * Will only work if the stream is replayable.
 *
 * We only use snapshot on Store by Developer policy or in unit tests.
 */
export const snapshot = <T>(o$?: Observable<T>): T => {
  let r: T;
  if (o$ instanceof Observable) {
    o$.pipe(take(1)).subscribe((s) => (r = s));
  }
  return r;
};
